export const analyticsLink =  "https://app.powerbi.com/links/KbM2tfHc6c?ctid=9ca75128-a244-4596-877b-f24828e476e2&pbi_source=linkShare";